<template>
  <v-row justify="center">
    <v-dialog
      v-model="shower"
      scrollable
      max-width="800"
      height="50"
      persistent
    >
      <v-card class="rounded-lg" max-height="500">
        <v-card-title>
          ประกาศว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล (Privacy Notice)
          <v-spacer></v-spacer>
          <v-icon @click="fn_close">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="pl-10 pr-10 pt-6 grey--text">
          <div class="pb-3">
            ระบบ Consent Management Platform (“CMP”)
            เคารพในสิทธิความเป็นส่วนตัวและตระหนักถึงความสำคัญในการเก็บรักษาข้อมูลส่วนบุคคลของท่าน
            (“ข้อมูลส่วนบุคคล”) ระบบ CMP
            จึงได้จัดทำประกาศฉบับนี้ขึ้นเพื่อการคุ้มครองข้อมูลส่วนบุคคลของท่านตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
            พ.ศ. 2562 (“พรบ. คุ้มครองข้อมูลส่วนบุคคล”)
          </div>
          <div class="pb-3"> <b>1. คำนิยาม</b> </div>
          <div class="pb-7"> <b> “CMP”</b> หมายถึง ระบบ Consent Management Platform</div>
          <div class="pb-3">
            <b>“ข้อมูลส่วนบุคคล”</b>  หมายถึง ข้อมูลเกี่ยวกับบุคคล
            ซึ่งทำให้สามารถระบุถึงตัวบุคคลนั้นได้ เช่น ชื่อ นามสกุล ที่อยู่
            วันเดือนปีเกิด เลขประจำตัวประชาชน หมายเลขโทรศัพท์ เพศ
            และให้หมายถึงข้อมูลอื่นใดเกี่ยวกับบุคคลใดบุคคลหนึ่ง
            ซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ ไม่ว่าทางตรงหรือทางอ้อม
          </div>
          <div class="pb-3">
            <b>“เจ้าของข้อมูล”</b>  หมายถึง บุคคลซึ่งเป็นเจ้าของข้อมูลส่วนบุคคล เช่น
            ลูกค้า
          </div>
          <div class="pb-3"> <b>“บุคคล”</b>  หมายถึง บุคคลธรรมดา</div>
          <div class="pb-3">
            <b>“การประมวลผล”</b>  หมายถึง การดำเนินการใดๆ เกี่ยวกับการใช้ การเปิดเผย
            หรือการแก้ไขซึ่งข้อมูลส่วนบุคคลของเจ้าของข้อมูล
            ไม่ว่าจะใช้วิธีการใดๆ
            และให้หมายความรวมถึงการส่งหรือโอนข้อมูลส่วนบุคคลที่ใช้ในการประกอบกิจการนั้นๆ
          </div>
          <div class="pb-3"> <b>2. วัตถุประสงค์ในการจัดเก็บข้อมูลส่วนบุคคล</b> </div>
          <div class="pb-3">
            ระบบ CMP
            อาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเมื่อท่านเข้าเยี่ยมชมหรือใช้งานเว็บไซต์
            CMP (https://cmp.inet.co.th) เพื่อการนำเสนอสินค้าหรือบริการ การโฆษณา
            การวิจัยหรือการจัดทำสถิติ การปรับปรุงคุณภาพของการให้บริการของระบบ
            CMP การจัดทำข่าวสารประชาสัมพันธ์
            และการส่งข้อมูลส่วนบุคคลโดยเป็นไปตามที่กฎหมายกำหนด
          </div>
          <div class="pb-3"> <b>3. ฐานในการประมวลผลข้อมูล</b> </div>
          <div class="pb-3">
            ระบบ CMP ดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ฐานการประมวลผล
            ดังต่อไปนี้
          </div>
          <div class="pb-3">
            ฐานความยินยอม (Consent) : ระบบ CMP
            จะเชิญชวนให้ท่านในฐานะเจ้าของข้อมูลยอมรับหรืออนุญาตให้มีการประมวลผลข้อมูลส่วนบุคคล
            โดยท่านสามารถเลือกที่จะยอมรับหรือปฏิเสธก็ได้
            และหากท่านเลือกที่จะปฏิเสธ ระบบ CMP
            ก็ไม่สามารถประมวลผลข้อมูลส่วนบุคคลของท่านได้
          </div>
          <div class="pb-3">
            ฐานสัญญา (Contract) :
            กรณีการประมวลผลข้อมูลจำเป็นต่อการให้บริการตามสัญญาที่ตกลงกันไว้ระหว่าง
            ระบบ CMP และท่าน
            หรือเมื่อจำเป็นต้องประมวลผลข้อมูลเพื่อปฏิบัติตามคำขอของท่านก่อนที่จะเข้าสู่การทำสัญญา
          </div>
          <div class="pb-3">
            ฐานประโยชน์สำคัญต่อชีวิต (Vital Interest) :
            กรณีที่การประมวลผลข้อมูลมีความจำเป็นต่อการปกป้องประโยชน์สำคัญของท่านหรือบุคคลอื่น
            เช่น
            ป้องกันอันตรายร้ายแรงอันอาจเกิดต่อสุขภาพและชีวิตด้วยการประมวลผลข้อมูลสุขภาพหรือข้อมูลอ่อนไหว
            (sensitive data) เป็นต้น
          </div>

          <div class="pb-3">
            ฐานจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย (Legitimate Interest) : ระบบ
            CMP อาจนำข้อมูลส่วนบุคคลของท่านไปใช้ในการประมวลผล การวิจัย
            หรือการจัดทำสถิติซึ่งเป็นไปตามวัตถุประสงค์ของการดำเนินงานของระบบ CMP
            การจัดทำรายงานการดำเนินงานภายในระบบ CMP
            การปรับปรุงคุณภาพของการให้บริการของระบบ CMP
            การจัดทำข่าวสารประชาสัมพันธ์ของระบบ CMP การวิเคราะห์
            การวัดการทำงานของเว็บไซต์
          </div>
          <div class="pb-3">
            ฐานการปฏิบัติตามกฎหมาย (Legal Obligation) : ระบบ CMP
            อาจต้องนำส่งข้อมูลส่วนบุคคลของท่านส่งมอบให้แก่พนักงานเจ้าหน้าที่หรือหน่วยงานรัฐที่มีอำนาจตามกฎหมายในการเรียกข้อมูลที่ระบบ
            CMP ครองครองอยู่ได้ เช่น กรมสรรพากร
            สำนักงานคณะกรรมการคุ้มครองผู้บริโภค สำนักงานตำรวจแห่งชาติ
            สำนักงานอัยการ ศาล เป็นต้น
          </div>
          <div class="pb-3"> <b>   4.
            ข้อมูลส่วนบุคคลที่จะทำการเก็บรวบรวมเพื่อประมวลผลและระยะเวลาในการเก็บรวบรวม</b>
          </div>
          <div class="pb-3">
            4.1 ประเภท/รายการข้อมูลส่วนบุคคลที่จะเก็บรวบรวมเพื่อประมวลผล
          </div>
          <div class="pb-3">- ชื่อ</div>

          <div class="pb-3">- นามสกุล</div>
          <div class="pb-3">- Email</div>
          <div class="pb-3">- IP Address</div>
          <div class="pb-3">4.2 ระยะเวลาในการเก็บรวบรวม</div>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-layout row wrap align-center justify-center>
            <v-flex xs2 lg2>
              <v-btn color="#077893" block dark outlined @click="fn_close()">
                ปิด
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ['show'],
  data: function () {
    return {}
  },
  created () {},
  computed: {
    shower: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.$emit('closeDialogTerm')
        }
      }
    }
  },
  watch: {},
  methods: {
    fn_close () {
      this.$emit('closeDialogTerm')
    }
  }
}
</script>
<style scoped>
.noteStlye {
  width: 300px;
  word-wrap: break-word;
}
</style>
